module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"vacancy":"Job","candidates":"Candidates","interview":"Interviews","questions":"Questions"}}')
  delete Component.options._Ctor
}
